module.exports = __webpack_public_path__ + "static/media/teradata.958287ba.png";